export const applyFormationFilters = (annonce, filters) => {
  const { secteur = [], prixMin, prixMax } = filters;

  const isSecteurFiltered = secteur.length === 0 || secteur.includes(annonce.secteur);
  const isPrixFiltered =
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax));

  return isSecteurFiltered && isPrixFiltered;
};
